import { Button, Group, Modal } from '@mantine/core';
import { IconDeviceFloppy, IconSettings } from '@tabler/icons-react';
import { useState } from 'react';
import ErrorMessage from '../ErrorMessage';
import SubscriptionSelectorForm from '../Subscriptions/SubscriptionSelectorForm';

const SubscriptionSelector = ({
  subscriptions,
  selectedSubscriptions: passedSelectedSubscriptions,
  onSelect,
  selectorTitle,
  size,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSubscriptions, setSelectedSubscriptions] = useState(passedSelectedSubscriptions);
  const [userError, setUserError] = useState();
  const [loading, setLoading] = useState();

  return (
    <>
      <Button variant="default" size={size} leftSection={<IconSettings size={size === 'lg' ? 20 : 16} />} onClick={() => setModalOpen(true)}>
        {selectorTitle || selectedSubscriptions.map((s) => s.name).join(' | ') || '(Choose subscriptions)'}
      </Button>

      <Modal size="90%" opened={modalOpen} onClose={() => setModalOpen(false)} title="Choose subscriptions">
        <form>
          <SubscriptionSelectorForm
            subscriptions={subscriptions}
            selectedSubscriptions={selectedSubscriptions}
            setSelectedSubscriptions={setSelectedSubscriptions}
          />
          <Group justify="flex-end" mt="md">
            {userError && <ErrorMessage message={userError?.message} />}
            <Button variant="default" onClick={() => setModalOpen(false)}>
              Cancel
            </Button>
            <Button
              disabled={loading}
              onClick={async () => {
                try {
                  setUserError(undefined);
                  setLoading(true);
                  await onSelect(selectedSubscriptions);
                  setModalOpen(false);
                } catch (e) {
                  setUserError(e);
                } finally {
                  setLoading(false);
                }
              }}
            >
              Save <IconDeviceFloppy size={16} />
            </Button>
          </Group>
        </form>
      </Modal>
    </>
  );
};

export default SubscriptionSelector;
